import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
export default Avatar;